<template slot-scope="scope">
  <el-select
    :value="localValue"
    :disabled="disabledFlag"
    @input="$emit('input', $event)"
    placeholder="请选择学段"
    clearable style="width: 100%">
    <el-option v-for="(item,index) in items" :key="index" :label="item.gradationName" :value="item.id"></el-option>
  </el-select>
</template>
<script>
  export default {
    props: {
      value: null,
      campusId: {
        type: String,
        default: '',
      },
      disabledFlag: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      value(val){
        this.localValue = val
      },
      campusId(){
        this.query();
      }
    },
    data() {
      return {
        localValue: this.value,
        items:[]
      }
    },
    methods: {
      query(){
        let vm = this
        if(!vm.campusId) {
          http.get(InterfacePrefix['platform'] + "/api/gradation?status=1").then(function(xhr) {
            if (xhr.data.code) return // 异常情况有公共处理
            vm.items = xhr.data
            //排除高职
            if(vm.items&&vm.items.length > 0){
              var arr = _.filter(vm.items,function (v) {
                return v.code != "GZ002"
              })
              vm.items = arr;
            }
          })
        } else {
          http.get(InterfacePrefix['platform'] + "/api/gradation?campusId="+vm.campusId+"&status=1").then(function(xhr) {
            if (xhr.data.code) return // 异常情况有公共处理
            vm.items = xhr.data
            vm.value=xhr.data[0].gradationName
          })
        }

      }
    },
    mounted() {
      this.query()
    },
  }

</script>



// WEBPACK FOOTER //
// src/commonplugin/chose_param/chooseGradation.vue